import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["productsList"];

  connect() {

  }

  toggleProductsList() {
    this.productsListTarget.classList.toggle("hidden");
  }


}